import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import "../../styles/loadingAnimation.sass";

// You'll need to import your Lottie animation file
// Replace this with your actual animation file path once you have it
import loadingAnimation from "../../assets/animations/loading-animation.json";

const LoadingAnimation = ({ isLoading, onAnimationComplete }) => {
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const [isFadingOut, setIsFadingOut] = useState(false);
    
    const loadingTexts = [
        "Processing your response...",
        "Calculating your longevity score...",
        "Analyzing your health patterns...",
        "Generating personalized insights...",
        "Preparing your results..."
    ];
    
    // Rotate through the loading texts every 3 seconds
    useEffect(() => {
        const textInterval = setInterval(() => {
            if (isLoading) {
                setCurrentTextIndex((prevIndex) => (prevIndex + 1) % loadingTexts.length);
            }
        }, 3000);
        
        return () => clearInterval(textInterval);
    }, [isLoading, loadingTexts.length]);
    
    // Handle fade out animation when loading is complete
    useEffect(() => {
        if (!isLoading && !isFadingOut) {
            setIsFadingOut(true);
            
            // Wait for fade out animation to complete before notifying parent
            const fadeOutTimer = setTimeout(() => {
                if (onAnimationComplete) {
                    onAnimationComplete();
                }
            }, 1000); // Match this with the CSS transition duration
            
            return () => clearTimeout(fadeOutTimer);
        }
    }, [isLoading, isFadingOut, onAnimationComplete]);
    
    // If not loading and fade out is complete, don't render anything
    if (!isLoading && !isFadingOut) {
        return null;
    }
    
    return (
        <div className={`loading-overlay ${isFadingOut ? 'fade-out' : ''}`}>
            <div className="loading-content">
                <div className="lottie-container">
                    <Lottie 
                        animationData={loadingAnimation} 
                        loop={true}
                        autoplay={true}
                        style={{ width: '100%', height: '100%' }}
                    />
                </div>
                <div className="loading-text">
                    {loadingTexts[currentTextIndex]}
                </div>
            </div>
        </div>
    );
};

export default LoadingAnimation; 